module.exports = __webpack_public_path__ + "img/logo-white-text.0abef25e.svg";